import { executeRequest, Request } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const parseResponse = (data: any) => {
  return data?.data?.data?.findFulFillmentByFulFillment_id
    ? data?.data?.data?.findFulFillmentByFulFillment_id?.[0]
    : data?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc
    ? {
        error: {
          message: data?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc,
          code: data?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.internalCode,
        },
      }
    : data?.data?.errors?.[0]?.message?.length > 0
    ? {
        error: {
          message: data?.data?.errors?.[0]?.message,
          code: data?.data?.errors?.[0]?.code,
        },
      }
    : null
}

const getCreateStatusRequestBody = (fulfillmentId: string) => {
  const queryObj = {
    findFulFillmentByFulFillment_id: {
      __args: {
        fulfillmentId: fulfillmentId,
      },
      fulfillmentId: true,
      identificationNumber: true,
      type: true,
      applicationId: true,
      errorStatus: {
        status: true,
      },
      jfsUserMgmt: {
        status: true,
      },
      errorDetail: {
        status: true,
        error: {
          code: true,
          message: true,
        },
      },
    },
  }

  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('getCreateStatusRequestBody query: ', query)
  return query
}

const checkCreationStatusReq = (applicationId: string, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.checkStatusCreateEntity,
    body: getCreateStatusRequestBody(applicationId),
    method: 'POST',
  }
  return executeRequest(request)
    .then((data) => {
      return parseResponse(data)
    })
    .catch((err) => {
      throw err
    })
}

export { checkCreationStatusReq }
